import React, { Component } from "react";
import AutoInput from "../containers/AutoInput";
import withValues from "../hocs/withValues";
import { getValue } from "../utils/models";
import { getBelongsToValue } from "../utils/models";
import impoivaMateriales from "../utils/impoIva";
import expoivaMateriales from "../utils/expoIva";

class LocalEdit extends Component {
  constructor(props) {
    super(props);

    this.state = {
      showContent: false,
      unitprice: getValue(this.props.values, "unitprice", 0),
      total: getValue(this.props.values, "total"),
      material: getValue(this.props.values, "material"),
      materialsQuery: null,
      iva: getValue(this.props.values, "iva"),
      materialEs: null,
      typeIva: getValue(this.props.values, "typeIva")
    };
  }

  componentDidUpdate(prevProps) {
    if (this.props.values.material !== prevProps.values.material) {
      this.setState({
        material: getValue(this.props.values, "material"),
        iva:getValue(this.props.values, "iva")
      });
    }
    if (this.props.values.unitprice !== prevProps.values.unitprice) {
      this.setState({
        unitprice: getValue(this.props.values, "unitprice")
      });
    }
    if (this.props.values.typeIva !== prevProps.values.typeIva) {
      this.setState({
        typeIva: getValue(this.props.values, "typeIva")
      });
    }
  }

  
  render() {
    let ivaFilter = "";
    if (this.state.iva === "16%") {
      ivaFilter = this.state.unitprice * 0.16;
    } else if (this.state.iva === 3) {
      ivaFilter = this.state.unitprice * 0.16;
    }

    return (
      <div>
        <AutoInput
          form={this.props.form}
          disabled={this.props.disabled}
          model={"quote"}
          id={this.props.id}
          attribute={"quote"}
          value={getBelongsToValue("quote", this.props.belongsTo)}
          hidden={true}
        />
        <AutoInput
          form={this.props.form}
          model={"local"}
          attribute={"typeIva"}
          type={"model"}
          items={["IMPORT", "EXPORT"]}
          onChange={value => {
            this.setState({ typeIva: value });
            this.props.form.resetFields(["material"]);
          }}
          value={getValue(this.props.values, "typeIva")}
        />
        <AutoInput
          form={this.props.form}
          model={"local"}
          attribute={"unitprice"}
          value={getValue(this.props.values, "unitprice")}
          onChange={value => {
            this.setState({ unitprice: value });
          }}
        />
        <AutoInput
          form={this.props.form}
          model={"local"}
          attribute={"material"}
          placeholder={"Select Service"}
          onSearch={value => {
            this.setState({ materialsQuery: value });
          }}
          onChange={value => {
            if(this.state.typeIva==="IMPORT"){
              const iva = impoivaMateriales.find(
                material => material.numero === value
              );
              if (iva) {
                this.setState({ iva: iva.iva });
              }
            }else if(this.state.typeIva==="EXPORT"){
              const iva = expoivaMateriales.find(
                material => material.numero === value
              );
              if (iva) {
                this.setState({ iva: iva.iva });
              }
            }
            this.setState({ material: value });
          }}
        />
        <AutoInput
          model={"local"}
          form={this.props.form}
          attribute={"iva"}
          value={this.state.iva}
          disabled
        />
        <AutoInput
          form={this.props.form}
          model={"local"}
          attribute={"total"}
          value={this.state.unitprice + ivaFilter}
          disabled
        />
      </div>
    );
  }
}

export default withValues(LocalEdit);



// WEBPACK FOOTER //
// ./src/forms/LocalEdit.js